import { FeatureCatalogResponse } from "../Models/featureCatalog";
import call from "./call";

export const getFeatureCatalog = async (): Promise<FeatureCatalogResponse> => {
  const response = await call.get("/v1/features_catalog/", {
    snack: {
      error: "featureCatalog.fetchError",
    },
  });
  return response.data;
};
